<template>
  <b-overlay
    id="overlay-background"
    class="overlay-config analysis-list"
    :show="loading"
    rounded="sm"
  >
    <div :class="{'sctCol': !editable, 'setColEditable': editable }">
      <label :class="{'editable': !editable}" for="process-select">{{$t('processTitle')}}</label>
      <SearchableSelect
        v-if="editable"
        id="process-select"
        class="form-control mt-1"
        :extraClass="'input-pentagro'"
        :modelRef="selectedProcess"
        :optList="processes"
        optValue="id"
        optDisplay="description"
        :inputFunc="(e) => selectedProcess = e.target.value ? Number(e.target.value) : null"
        placeholder="Selecione um processo"
      />
      <label v-else>{{ returnElementById(processes, selectedProcess) }}</label>
    </div>
    <div :class="{'sctCol': !editable, 'setColEditable': editable }">
      <label :class="{'editable': !editable}" for="equipment-select">{{$t('equipmentTitle')}}</label>
      <SearchableSelect
        v-if="editable"
        id="equipment-select"
        class="form-control mt-1"
        :extraClass="'input-pentagro'"
        :modelRef="selectedEquipment"
        :optList="filteredEquipments"
        optValue="id"
        optDisplay="description"
        :disabled="!selectedProcess"
        :inputFunc="(e) => selectedEquipment = e.target.value ? Number(e.target.value) : null"
        placeholder="Selecione um equipamento"
      />
      <label v-else>{{ returnElementById(equipments, selectedEquipment) }}</label>
    </div>
    <div :class="{'sctCol': !editable, 'setColEditable': editable}">
      <label :class="{'editable': !editable}" for="product-select">{{$t('productTitle')}}</label>
      <SearchableSelect
        v-if="editable"
        id="product-select"
        class="form-control mt-1"
        :extraClass="'input-pentagro'"
        :modelRef="selectedProduct"
        :optList="products"
        optValue="id"
        optDisplay="description"
        :inputFunc="(e) => selectedProduct = e.target.value ? Number(e.target.value) : null"
        placeholder="Selecione um produto"
      />
      <label v-else>{{ returnElementById(products, selectedProduct) }}</label>
    </div>
  </b-overlay>
</template>

<script>
import { urlMainAPI } from "@/global";
import axios from "axios";
import SearchableSelect from "../rta/commons/SearchableSelect.vue";

export default {
  name: "SelectOrigin",
  components: { SearchableSelect },

  props: ["selected", "editable"],

  data() {
    return {
      selectedProcess: this.selected.processId,
      selectedEquipment: this.selected.equipmentId,
      selectedProduct: this.selected.productId,
      selectedProcessName: this.selected.processName,
      selectedEquipmentName: this.selected.equipmentName,
      selectedProductName: this.selected.productName,
      loading: false,
      processes: [],
      equipments: [],
      products: [],
      filteredEquipments: []
    };
  },

  watch: {
    selectedProcess(value) {
      if (!value) {
        this.$emit("selectedProcess", null);
        this.$emit("selectedProcessName", "");
        this.selectedEquipment = null;
        this.filterEquipmentsByProcess(null);
        return;
      }
      const process = this.processes.find(p => p.id === value);
      this.$emit("selectedProcess", value);
      this.$emit("selectedProcessName", process ? process.description : "");
      this.selectedEquipment = null;
      this.filterEquipmentsByProcess(value);
    },
    selectedEquipment(value) {
      this.$emit("selectedEquipment", value);
      const equipment = this.equipments.find(x => x.id == value);
      if (equipment) {
        this.$emit("selectedEquipmentName", equipment.description);
      } else {
        this.$emit("selectedEquipmentName", "");
      }
    },
    selectedProduct(value) {
      this.$emit("selectedProduct", value);
      const prod = this.products.find(x => x.id == value);
      this.$emit("selectedProductName", prod ? prod.description : "");
    },
  },

  methods: {
    async loadProcess() {
      const url = `${urlMainAPI}/getprocess`;
      await axios.get(url).then((res) => {
        if (res.data) {
          this.processes = res.data;
        }
      });
    },

    async loadEquipments() {
      const url = `${urlMainAPI}/getequipments`;
      await axios.get(url).then((res) => {
        if (res.data) {
          this.equipments = res.data;
          this.filterEquipmentsByProcess(this.selectedProcess);
        }
      });
    },

    filterEquipmentsByProcess(processId) {
      if (!processId) {
        this.filteredEquipments = [];
        return;
      }
      
      this.filteredEquipments = this.equipments.filter(equipment => 
        equipment.processId === processId
      );
    },

    async loadProducts() {
      const url = `${urlMainAPI}/getproducts`;
      await axios.get(url).then((res) => {
        if (res.data) {
          this.products = res.data;
        }
      });
    },

    returnElementById(array = [], i) {
      let el = array.find(x => x.id == i)
      if (el)
        return el.description
      else
        return 'Não Atribuído'
    },

    async loadOrigin() {
      this.loading = this.editable;
      await this.loadProcess();
      await this.loadEquipments();
      await this.loadProducts();
      this.loading = false;
    }
  },

  async created() {
    await this.loadOrigin();
  },
};
</script>

<style scoped src=".\occurrence.css"></style>
<style scoped>
.editable {
  font-weight: 700;
  margin-bottom: 0px;
}

.sctCol {
  display: grid;
  grid-template-rows: auto auto;
}

.setColEditable {
  width: 350px;
}
</style>
